const state = {
  items: [],
  meta: {
    total: 0,
  },
};

export default {
  namespaced: true,

  state: { ...state },

  mutations: {
    SET_ITEMS(state, payload) {
      state.items = payload;
    },

    SET_META_TOTAL(state, payload) {
      state.meta.total = payload;
    },

    INCREASE_META_TOTAL(state) {
      state.meta.total = state.meta.total + 1;
    },
  },

  actions: {},
};
